(function ($) {
  'use strict';


  var init = function (paragraph) {
    var $videoContainer = paragraph.find('.video');
    var $player = paragraph.find('iframe');
    var $cta = paragraph.find('.cta-block');

    if ($player.length) {
      //var $videoButton = paragraph.find('.video-controls-overlay a.play-video');
      var $videoButton = paragraph.find('.video-controls-overlay');
      var $closeBtn = paragraph.find('span.close');

      $player.on('onStop', function () {
        $videoContainer.fadeOut(600);
        paragraph.removeClass('playing');
      });


      $videoButton.on('click', function (e) {
        paragraph.addClass('playing');
        $videoContainer.delay(300).fadeIn(600, function () {
        });
        $player.data('player').controls.play();
        e.preventDefault();
      });

      $closeBtn.on('click', function () {
        $player.data('player').controls.pause();
        paragraph.removeClass('playing');
        $videoContainer.fadeOut(600, function () {
          $player.data('player').controls.stop();
        });
      });
    }
  };

  Drupal.behaviors.initVideoPlayer = {
    attach: function (context) {
      $(context).find('.hero-option-1.video').once('video-formatter', function () {
        init($(this));
      });
    }
  };
}(jQuery));
